import { useQuery } from "@tanstack/react-query";
import { useDebounce } from "use-debounce";
import { useState } from "react";
import { getQuarterInfo, getQuarterStartDate } from "@/modules/targets/utils";
import { getPaginatedAssignedUsers } from "@/modules/common/api/index.v2";
import { OrderDirection } from "@/api/types";
import { UsersOrderByOptions } from "@/modules/user/api/types";

export const useUsersWithTargets = ({
  year,
  quarter,
}: {
  year: number;
  quarter: number;
}) => {
  const [usersSearchTerm, setUsersSearchTerm] = useState("");
  const [debouncedSearchTerm] = useDebounce(usersSearchTerm, 300);

  const quarterInfo = getQuarterInfo(getQuarterStartDate(year, quarter));

  const { data: usersData, isLoading } = useQuery({
    queryKey: [
      "getTargetsUsers",
      quarterInfo.startDate,
      quarterInfo.endDate,
      debouncedSearchTerm,
    ],
    queryFn: async () => {
      const response = await getPaginatedAssignedUsers({
        page: 1,
        pageSize: 50,
        orderBy: UsersOrderByOptions.RANK,
        orderDirection: OrderDirection.DESCENDING,
        ...(debouncedSearchTerm && { name: debouncedSearchTerm }),
      });
      return response.data.results;
    },
  });

  return {
    usersData,
    isLoading,
    usersSearchTerm,
    setUsersSearchTerm,
  };
};
